const PersianaIcon = ({ color, height = '32px', width = '32px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-testid="persianist"
  >
    <title>a-icons / 32px / services / person blinds</title>
    <g
      id="a-icons-/-32px-/-services-/-person-blinds"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M31.5,0 C31.7453333,0 31.9495802,0.176987654 31.9919396,0.410161866 L32,0.5 L32,31.5 C32,31.7453333 31.8230123,31.9495802 31.5898381,31.9919396 L31.5,32 L0.5,32 C0.254666667,32 0.0504197531,31.8230123 0.00806035665,31.5898381 L0,31.5 L0,0.5 C0,0.254666667 0.176987654,0.0504197531 0.410161866,0.00806035665 L0.5,0 L31.5,0 Z M1.868,23.389 L1,23.389 L1,31 L31,31 L31,23.389 L16.5,23.389 L16.5,29.131 L29.131,29.131 L29.131,23.41 L30.131,23.41 L30.131,29.631 C30.131,29.8763333 29.9540123,30.0805802 29.7208381,30.1229396 L29.631,30.131 L2.368,30.131 C2.12266667,30.131 1.91841975,29.9540123 1.87606036,29.7208381 L1.868,29.631 L1.868,23.389 Z M15.5,23.389 L2.868,23.389 L2.868,29.131 L15.5,29.131 L15.5,23.389 Z M31,20.596 L1,20.596 L1,22.389 L31,22.389 L31,20.596 Z M31,17.804 L1,17.804 L1,19.596 L31,19.596 L31,17.804 Z M31,15.011 L1,15.011 L1,16.804 L31,16.804 L31,15.011 Z M31,12.219 L1,12.219 L1,14.011 L31,14.011 L31,12.219 Z M31,9.426 L1,9.426 L1,11.219 L31,11.219 L31,9.426 Z M31,6.634 L1,6.634 L1,8.426 L31,8.426 L31,6.634 Z M31,3.841 L1,3.841 L1,5.634 L31,5.634 L31,3.841 Z M31,1 L1,1 L1,2.841 L31,2.841 L31,1 Z"
        id="Shape"
        fill={color || '#00008F'}
      ></path>
    </g>
  </svg>
);

export default PersianaIcon;
